export const ALL = 'all';
export const PENDING = 'pending';
export const COMPLETE = 'complete';
export const FAILED = 'failed';


export const ALL_LABEL = 'All Requests';
export const PENDING_LABEL = 'Pending';
export const COMPLETE_LABEL = 'Complete';
export const FAILED_LABEL = 'Failed';

function getLabelByKey(key) {
    switch (key) {
        case ALL:
            return ALL_LABEL;
        case PENDING:
            return PENDING_LABEL;
        case COMPLETE:
            return COMPLETE_LABEL;
        case FAILED:
            return FAILED_LABEL;
        default:
            return ''; // Handle the case where the baseValue is not found
    }
}

function mapUpdateRequestStatuses() {
    return [
        {
            key: ALL,
            text: ALL_LABEL,
        },
        {
            key: PENDING,
            text: PENDING_LABEL,
        },
        {
            key: COMPLETE,
            text: COMPLETE_LABEL,
        },
        {
            key: FAILED,
            text: FAILED_LABEL,
        }
    ];
}

export {getLabelByKey, mapUpdateRequestStatuses}
